var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.0693,
    cy: 16.6517,
    r: 2.54522,
    stroke: "url(#paint0_linear_648_1675)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3326,
    cy: 29.4417,
    r: 2.54522,
    stroke: "url(#paint1_linear_648_1675)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.641,
    cy: 37.3592,
    r: 2.54522,
    stroke: "url(#paint2_linear_648_1675)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3326,
    cy: 44.6678,
    r: 2.54522,
    stroke: "url(#paint3_linear_648_1675)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.0693,
    cy: 57.4573,
    r: 2.54522,
    stroke: "url(#paint4_linear_648_1675)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1064 27.9189H52.5878L58.0692 23.0465V19.6968",
    stroke: "url(#paint5_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8019 32.4865H53.5014L56.8511 29.1367H59.2873",
    stroke: "url(#paint6_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5347 37.3589L66.5959 37.3589",
    stroke: "url(#paint7_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4974 42.2314H54.1105L56.8512 44.9721H59.2874",
    stroke: "url(#paint8_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1064 47.4082H52.2833L57.7647 51.6715V54.4122",
    stroke: "url(#paint9_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8391 34.0094C36.7527 35.329 39.3107 37.7855 42.2341 37.0546C45.1575 36.3238 46.0913 34.3139 46.1929 33.4004V18.1743C45.9898 16.6517 44.6093 13.6064 40.7115 13.6064C36.8136 13.6064 35.8391 16.6517 35.8391 18.1743C35.8391 19.5954 36.2045 22.5594 37.6662 23.0466",
    stroke: "url(#paint10_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8391 17.2607C34.5195 17.2607 31.7585 18.1743 31.2713 21.8286C29.6472 21.321 26.1553 21.0368 25.1809 23.9602C23.9628 27.6145 25.4854 29.7461 26.7035 30.9642",
    stroke: "url(#paint11_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.652 26.3965C23.5424 26.7 21.2023 27.7318 20.7181 29.4312C20.1129 31.5555 19.8102 35.1972 22.5337 36.4111C24.7125 37.3822 33.3269 37.4226 37.3617 37.3215",
    stroke: "url(#paint12_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5347 41.0135C36.1437 39.7954 38.0927 37.481 41.0161 37.9682C44.6703 38.5773 45.8884 38.2728 46.1929 41.0135C46.4366 43.206 46.2944 52.8897 46.1929 57.4576C45.9899 58.6757 44.7921 61.1118 41.6251 61.1118C37.6663 61.1118 36.7528 59.8937 36.1437 58.0666C35.5347 56.2395 36.7528 53.1943 37.9708 51.9762",
    stroke: "url(#paint13_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8391 57.4574C34.9255 57.3559 32.733 56.4829 31.2712 53.8031C28.7336 53.8031 23.8409 52.8287 24.5718 48.9308C25.3026 45.0329 26.5004 44.2614 27.0079 44.3629",
    stroke: "url(#paint14_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2673 48.6262C22.9478 48.0172 20.2477 46.0073 20.004 42.8403C19.7604 39.6733 22.7447 37.8664 24.2673 37.3589",
    stroke: "url(#paint15_linear_648_1675)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7195 94C54.7195 92.2744 55.3285 88.275 57.7647 86.0824C60.8099 83.3417 62.9416 82.7327 65.0732 83.0372C67.2049 83.3417 74.5134 84.5599 75.7315 84.2554C76.9496 83.9509 79.0812 82.7328 79.0812 82.1238C79.0812 81.5147 77.7913 77.0907 78.4722 75.7288C79.3858 73.9017 80.8069 72.9881 81.2129 72.3791C80.5023 71.2625 79.0203 69.882 77.5586 69.6384C78.8782 69.2323 81.5174 68.2376 81.5174 67.5067C81.5174 66.5931 79.9948 63.8524 81.5174 62.6344C83.04 61.4163 86.3898 60.1982 86.0852 58.3711C85.7807 56.5439 79.0812 52.5851 79.0812 45.8857C79.0812 39.1862 79.9948 31.8777 76.3405 25.1782C72.6863 18.4787 65.0732 7.5159 51.6743 6.29782C38.2753 5.07973 32.1849 7.5159 23.0492 15.129C13.9136 22.742 13 34.9229 13 39.1862C13 43.4495 15.1317 51.6716 19.0904 56.8485C23.0492 62.0253 24.5718 63.8524 24.2673 69.6384C23.9628 75.4243 19.0904 91.8682 17.2633 94",
    stroke: "url(#paint16_linear_648_1675)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_1675",
    x1: 61.1145,
    y1: 14.1935,
    x2: 49.2638,
    y2: 23.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_648_1675",
    x1: 65.3778,
    y1: 26.9835,
    x2: 53.5271,
    y2: 36.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_648_1675",
    x1: 72.6863,
    y1: 34.901,
    x2: 60.8356,
    y2: 43.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_648_1675",
    x1: 65.3778,
    y1: 42.2096,
    x2: 53.5271,
    y2: 51.2352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_648_1675",
    x1: 61.1145,
    y1: 54.9991,
    x2: 49.2638,
    y2: 64.0247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_648_1675",
    x1: 58.0692,
    y1: 20.4893,
    x2: 41.4759,
    y2: 37.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_648_1675",
    x1: 59.2873,
    y1: 29.4596,
    x2: 55.0497,
    y2: 41.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_648_1675",
    x1: 66.5959,
    y1: 37.4553,
    x2: 66.4256,
    y2: 41.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_648_1675",
    x1: 59.2874,
    y1: 42.4956,
    x2: 56.4029,
    y2: 52.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_648_1675",
    x1: 57.7647,
    y1: 48.0833,
    x2: 43.7805,
    y2: 64.2907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_648_1675",
    x1: 46.1929,
    y1: 15.8793,
    x2: 17.5624,
    y2: 25.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_648_1675",
    x1: 35.8391,
    y1: 18.5816,
    x2: 11.1143,
    y2: 33.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_648_1675",
    x1: 37.3617,
    y1: 27.4531,
    x2: 15.5488,
    y2: 53.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_648_1675",
    x1: 46.3274,
    y1: 40.139,
    x2: 16.8437,
    y2: 50.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_648_1675",
    x1: 35.8391,
    y1: 45.6174,
    x2: 11.5338,
    y2: 61.6393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_648_1675",
    x1: 24.2673,
    y1: 38.4449,
    x2: 12.1314,
    y2: 41.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_648_1675",
    x1: 86.1047,
    y1: 14.4819,
    x2: -74.4001,
    y2: 116.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationAgents);
export default __webpack_public_path__ + "static/media/evaluation-agents.71263d0ca7895d5df2a97dd0f79add5b.svg";
export { ForwardRef as ReactComponent };